export const entities = [
    {
        name: "ElemDataLine",
        collectionName: "slp.elemData",
        fields: [
            {path: "date", type: "date"},
            {path: "store", type: "string"},
            {path: "incomplete", type: "boolean"},
            "Product",
            "Store",
            {type: "Organization", link: "MTM"},
            {type: "Family", link: "MTM"},
            {path: "ticket"},
            {path: "ticketCustomer"},
            {path: "order"},
            {path: "cashier"}
        ],
        indexes:[
            {key: {"group": 1, "date": 1}},
            {key: {"group": 1, "incomplete": 1}},
            {key: {"group": 1, "date": 1, "origin": 1}},
            {key: {"group": 1, "date": 1, "organizations": 1}},
            {key: {"group": 1, "date": 1, "familys": 1}},
            {key: {"group": 1, "date": 1, "ticket": 1}},
            {key: {"group": 1, "date": 1, "ticketCustomer": 1}},
            {key: {"group": 1, "date": 1, "cashier": 1}},
        ]
    },
    {
        name: "ScoringIntermediate",
        collectionName: "slp.scoringIntermediate",
        fields: [
            {path: "infiniteFraction", type: "boolean", index: true},
            {path: "comparison", type: "string", index: true}
        ]
    }
]
